import gql from 'graphql-tag';

export default gql`
  fragment SeatOrderItemFragment on OrderItem {
    ... on SeatOrderItem {
      id
      flightId
      travelerId
      column
      row
      price {
        amount
        currency
      }
      exitRow
      seatPrice {
        subtotal
        taxes {
          breakdown {
            name
            code
            value {
              amount
            }
          }
          total {
            amount
            currency
          }
        }
        taxesIncludedInBundle {
          breakdown {
            name
            code
            value {
              amount
            }
          }
          total {
            amount
            currency
          }
        }
        total
        isUpgradePrice
      }
      bundledAncillaryPrice {
        amount
      }
      isBundledAncillaryIncluded
      seatSizeId
    }
  }
`;
